import styled from "styled-components";

import Background from "../../images/backgroundLaborLaw.png";

export const Container = styled.section`
  background-image: url(${Background});
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 20px;

  h1 {
    font-size: 40px;
    font-family: "Noto Serif";
    color: #139ed5;
    text-align: center;
  }

  p {
    font-size: 16px;
    color: #1d364a;
    text-align: center;
    font-family: "Montserrat";
  }
`;

export const Content = styled.div`
  max-width: 1262px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Cards = styled.div`
  display: flex;
  gap: 20px;
  padding-top: 100px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding-top: 0;
  }
`;
